import { useContext } from "react";
import {
  FilePreviewContext,
  FilePreviewContextValue,
} from "./FilePreviewProvider";

export function useFilePreview(): FilePreviewContextValue {
  const ctx = useContext(FilePreviewContext);
  if (!ctx) {
    throw new Error(
      "useFilePreview must be used within a FilePreviewProvider",
    );
  }
  return ctx;
}
